const styles = (theme) => ({
  label: {
    margin: '0 0 8px 0',
  },
  input: {
    marginBottom: '15px',
  },
  splitContainerRight: {
    paddingLeft: '8px',
    width: '50%',
  },
  splitContainerLeft: {
    paddingRight: '8px',
    width: '50%',
  },
  button: {
    marginBottom: '20px',
  },
  contentContainer: {
    width: '450px',
  },
  footerText: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    fontWeight: 500,
  },
  socialsText: {
    color: theme.palette.text.primary,
    marginRight: theme.spacing(1),
    fontSize: '14px',
    fontWeight: 500,
  },
  socialButtonsContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  socialButton: {
    margin: theme.spacing(.5),
  },
  descriptionContainer: {
    margin: '20px 0 10px 0',
  },
  facebookIcon: {
    width: '18px',
    height: '18px',
    color: theme.palette.common.white,
  },
  recaptcha: {
    width: '100%',
    marginBottom: '16px',
    display: 'flex',
    justifyContent: 'center',
  },
});

export default styles;
